// @flow

import unifizeUser from "./index";
import Department from "src/components/user/Department";

export default unifizeUser(Department);
